var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.749.334l-.25 1.667H8.832l-.769 5.62h7.683l-.221 1.643H7.843l-.89 6.573h7.688l-.199 1.643H5L7.319.337l9.43-.003zM27.519 3.595l-1.613.408a3.484 3.484 0 00-1.073-1.713 2.439 2.439 0 00-1.608-.629 2.022 2.022 0 00-1.556.647c-.4.43-.601 1.006-.601 1.73.023.711.245 1.401.64 1.993.266.435.905 1.111 1.917 2.028 1.046.947 1.778 1.831 2.197 2.651.39.743.598 1.567.606 2.406a4.646 4.646 0 01-.68 2.4 4.983 4.983 0 01-1.837 1.82 4.823 4.823 0 01-2.44.663 4.199 4.199 0 01-2.85-1.045c-.804-.697-1.38-1.722-1.73-3.077l1.584-.536c.249 1.025.655 1.787 1.22 2.286.527.484 1.22.75 1.936.745a2.882 2.882 0 002.142-.921 3.124 3.124 0 00.9-2.265 4.033 4.033 0 00-.51-1.946c-.336-.63-.998-1.385-1.986-2.265-1.056-.964-1.744-1.702-2.062-2.214a5.116 5.116 0 01-.78-2.704c0-1.172.382-2.141 1.147-2.908A3.867 3.867 0 0123.331.001a3.932 3.932 0 012.552.91c.741.601 1.286 1.496 1.636 2.684z",
    fill: "#009688"
  })));
}

export default SvgEs;